import { FC, useRef } from 'react';
import { SvgIcon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconWhatsapp } from 'src/assets/svg/whatsapp-logo.svg';

import { appConfig } from '../../../app/app-config';

import { ContactUsButton } from './contact-us-button';

export const WhatsappButton: FC = () => {
    const { t } = useTranslation();
    const Icon = useRef(
        <SvgIcon>
            <IconWhatsapp />
        </SvgIcon>
    );

    return (
        <ContactUsButton icon={Icon.current} href={appConfig.contacts.whatsappUrl} newTab>
            <Typography>{t('contact_us_whatsapp')}</Typography>
        </ContactUsButton>
    );
};
